var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Anpinnen'),expression:"'Anpinnen'"}],staticClass:"ui icon button pin-link",class:{active: _vm.pin},attrs:{"title":_vm.title},on:{"click":_vm.togglePin}},[_c('i',{staticClass:"ui icon suus-pin",class:{blue: _vm.pin }}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }